export const getInitialState = () => ({
    fetchStatus: "initial",
    error: undefined,
    searchAiSummary: {}
});
